<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">
      Редактировать тарифный план
    </h1>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'rate-plan-details', params: { id: rate_plan.id }}">← Назад к Деталям тарифного плана</router-link>
    </div>

    <div class="text-right">
      <a v-if="rate_plan.id" class="red" href="#" @click.prevent="deleteRatePlan">удалить тарифный план</a>
    </div>

    <rate-plan-edit-form
      :rate-plan="rate_plan"
      @after="handleAfter"
    />

  </div>
</template>

<script>
import { getRatePlan, deleteRatePlan } from '@/services/rate_plan.service'
import ratePlanEditForm from '@/components/forms/rate_plan/RatePlanEditForm'

export default {
  name: 'rate-plan-edit',
  components: { ratePlanEditForm },
  data () {
    return {
      rate_plan: {
        id: null,
        name: '',
        amount: '',
        period: ''
      },

      errors: {
        rate_plan: {
          id: [],
          name: [],
          amount: [],
          period: []
        },
        non_field_errors: []
      }
    }
  },
  mounted () {
    if (this.$route.params.id !== undefined) {
      this.rate_plan.id = this.$route.params.id

      getRatePlan(this.rate_plan.id).then((response) => {
        this.rate_plan = response.data
      })
    }
  },
  methods: {
    deleteRatePlan () {
      deleteRatePlan(this.rate_plan.id).then((response) => {
        this.showMsg('Тарифный план был удален!', 'success', 'Успешно')
        this.$router.push({ name: 'rate-plans' })
        return true
      }).catch(err => {
        this.fillErrors(this.errors.rate_plan, err.response.data)

        if (this.errors.non_field_errors[0]) {
          this.$parent.$parent.showPopupMsg(this.errors.non_field_errors[0], 'error')
        }

        return false
      })
    },
    handleAfter (success) {
      console.log(success)
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// RatePlanEdit.vue?02912b81